import * as React from "react";

import {useMutation} from "@khan/data-gql";

import {FORGOT_PASSWORD_MUTATION} from "./forgot-password-mutation-query.ts";

interface ForgotPasswordResultData {
    error?:
        | {
              code: string;
          }
        | null
        | undefined;
}

interface ForgotPasswordResult {
    isLoading: boolean;
    isError: boolean;
    data: ForgotPasswordResultData | null | undefined;
}

interface Props {
    children: (
        submitForgotPassword: (email: string) => void,
        result: ForgotPasswordResult,
    ) => React.ReactNode;
}

export default function ForgotPasswordMutation({children}: Props) {
    const [sendForgotPasswordLink, mutationResult] = useMutation(
        FORGOT_PASSWORD_MUTATION,
    );

    const submitForgotPassword = React.useCallback(
        (email: string) => {
            sendForgotPasswordLink({email});
        },
        [sendForgotPasswordLink],
    );

    const result: ForgotPasswordResult = React.useMemo(() => {
        const isLoading = mutationResult?.status === "loading";
        const isError = mutationResult?.status === "error";
        const data =
            mutationResult?.status === "success"
                ? {
                      error: mutationResult.data.forgotPassword?.error,
                  }
                : null;

        return {
            isLoading,
            isError,
            data,
        };
    }, [mutationResult]);

    return children(submitForgotPassword, result);
}
